import RoutingPlans from 'components/RoutingPlans';
import { RoutingPlans as RoutingPlansType } from 'schemas/RoutingPlan.schema.ts';

type RuleRoutingStatusProps = {
  teamRoutingPlans?: RoutingPlansType;
  commsRouting?: string;
};

export default function RuleRoutingStatus({ teamRoutingPlans = [], commsRouting }: RuleRoutingStatusProps) {
  const routingIds = commsRouting?.split('|').filter((id) => id.trim().length > 0) ?? [];
  return (
    <>
      <p className="nhsuk-u-margin-bottom-2 nhsuk-u-margin-top-5">
        <strong>Message plans:</strong>
      </p>

      <RoutingPlans teamRoutingPlans={teamRoutingPlans} routingIds={routingIds} />
    </>
  );
}
